import ProductItem from '../components/product/ProductItem';

const selectors = {
  showcaseModalContent: '[data-showcase-modal-content]',
  productItem: '[data-product-item]',
};

/**
 * Initializes all showcase modal content on the page (e.g. ProductItem for product lists).
 * Runs globally so showcase modals work wherever they appear (card feed, image block, etc.)
 * @param {HTMLElement} [container=document] - Optional container to limit initialization scope
 */
export default function initShowcase(container = document) {
  const showcaseContents = container.querySelectorAll(selectors.showcaseModalContent);

  showcaseContents.forEach(showcase => {
    const productItems = showcase.querySelectorAll(selectors.productItem);
    productItems.forEach(item => new ProductItem(item));
  });
}
